import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Conditional classes, with later Tailwind utilities beating earlier conflicting ones. */
export function cx(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
